// organize-imports-ignore
import { createNotivue } from 'notivue';

import 'notivue/animations.css'; // Only needed if using built-in animations
import 'notivue/notification.css'; // Only needed if using built-in notifications
import '~/styles/notivue.scss'; // Custom styles for Notivue

const notivue = createNotivue({
  position: 'top-right',
  limit: 4,
  enqueue: false, // https://docs.notivue.smastrom.io/stream-customization/limit-and-queue
  avoidDuplicates: true,
  notifications: {
    global: {
      duration: 5000,
    },
  },
});

export { notivue };
